import React, { Component } from 'react';
import * as Styles from './Styles';
import SvgOc from '../../../others/svg_dist/Oc';
import SvgLegal from '../../../others/svg_dist/Legal';
import SvgNnw from '../../../others/svg_dist/Nnw';

type Props = {};

type State = {};

class Banner extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper>
				<Styles.VideoContainer>
					<video autoPlay loop muted>
						<source src="/backgrounds/bg_start.mp4" />
					</video>
				</Styles.VideoContainer>
				<Styles.FontContainer>
					<Styles.FontSmall>
						<strong>Program Ubezpieczeń</strong> dla Ratowników
					</Styles.FontSmall>
					<Styles.FontBig>
						Wodnego Ochotniczego Pogotowia
					</Styles.FontBig>
					<Styles.FontBig>Ratunkowego</Styles.FontBig>
					<Styles.Line style={{ marginTop: '40px' }} width="80%" />
					<Styles.FontMedium>
						Zabezpiecz się już dziś i wybierz zakres ubezpieczenia!
					</Styles.FontMedium>
					<Styles.Line width="80%" />
				</Styles.FontContainer>
				<Styles.BannerDecorsContainer>
					<Styles.DecorContainer>
						<Styles.DecorImage
							src="/decors/lifebuoy_2.png"
							alt="dekor koło ratunkowe"
						/>
						<Styles.DecorImageContent>
							<SvgOc />
							<p>Odpowiedzialności Cywilnej</p>
						</Styles.DecorImageContent>
					</Styles.DecorContainer>
					<Styles.DecorContainer>
						<Styles.DecorImage
							src="/decors/lifebuoy_3.png"
							alt="dekor koło ratunkowe"
						/>
						<Styles.DecorImageContent>
							<SvgLegal />
							<p>Kosztów Ochrony Prawnej</p>
						</Styles.DecorImageContent>
					</Styles.DecorContainer>
					<Styles.DecorContainer>
						<Styles.DecorImage
							src="/decors/lifebuoy_2.png"
							alt="dekor koło ratunkowe"
						/>
						<Styles.DecorImageContent>
							<SvgNnw />
							<p>Następstw Nieszczęśliwych Wypadków</p>
						</Styles.DecorImageContent>
					</Styles.DecorContainer>
				</Styles.BannerDecorsContainer>
			</Styles.Wrapper>
		);
	}
}

export default Banner;
